import BaseService from '@/ecm/common/BaseService.js'

class WidgetService {
  baseUrl = 'widget';

  getData = (widget) => BaseService.post({ url: `${this.baseUrl}/get-data`, data: widget });
  getList = () => BaseService.get({ url: `${this.baseUrl}/get-list` });
  getForUser = () => BaseService.get({ url: `${this.baseUrl}/get-for-user` });
  getForUserId=(id)=>BaseService.post({url:`${this.baseUrl}/get-for-user-id/${id}` })
  add = (widget) => BaseService.post({ url: `${this.baseUrl}/add`, data: widget });
  delete = (userWidgetID) => BaseService.post({ url: `${this.baseUrl}/delete/${userWidgetID}` });
  updateSettings = (settings) => BaseService.post({ url: `${this.baseUrl}/update-settings`, data: settings });
  updateLayout = (layout) => BaseService.post({ url: `${this.baseUrl}/update-layout`, data: layout });  
  importLayout = (data) => BaseService.post({ url: `${this.baseUrl}/import-layout`, data: data });  
  refreshData = (data) => BaseService.post({ url: `${this.baseUrl}/refresh-data`, data: data });
  getPublicDashboardUsers = () => BaseService.get({url: `${this.baseUrl}/get-public-dashboards-users`})
}

export default new WidgetService()
